import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3eaf7136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-faculty-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "course-faculty-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-l-bold" }, "Faculty")
], -1))
const _hoisted_3 = { class: "course-faculty-content" }
const _hoisted_4 = { class: "content-list" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "text-m-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedSpeakers, (speaker) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "content-item",
            key: speaker.id
          }, [
            _createElementVNode("img", {
              class: "content-item-avatar",
              src: speaker.avatar?.presets['150x150'] || speaker.avatar?.url,
              alt: speaker.name
            }, null, 8, _hoisted_5),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(speaker.name) + " " + _toDisplayString(speaker.degree), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speaker.lines, (line, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content-item-description",
                  key: index
                }, _toDisplayString(line), 1))
              }), 128))
            ])
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "read-more",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('onReadMore')))
        }, "Read more")
      ])
    ])
  ]))
}